"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.tileVersionTileSizeRegistry = exports.TILE_XL_AREA = exports.TILE_L_AREA = exports.TILE_S_AREA = exports.tileSizeSpaceRegistry = void 0;
const ui_1 = require("../_components/ui");
const Tile_contracts_1 = require("./Tile.contracts");
/**
 * Registry that binds the `TileSize` with the space in the grid it requires to render properly;
 * divided by different breakpoints.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.tileSizeSpaceRegistry = {
    [ui_1.TileSize.S]: {
        [Tile_contracts_1.Breakpoint.XS]: {
            colSpan: 1,
            rowSpan: 1
        },
        [Tile_contracts_1.Breakpoint.MD]: {
            colSpan: 1,
            rowSpan: 1
        },
        [Tile_contracts_1.Breakpoint.LG]: {
            colSpan: 2,
            rowSpan: 2
        }
    },
    [ui_1.TileSize.L]: {
        [Tile_contracts_1.Breakpoint.XS]: {
            colSpan: 1,
            rowSpan: 1
        },
        [Tile_contracts_1.Breakpoint.MD]: {
            colSpan: 2,
            rowSpan: 2
        },
        [Tile_contracts_1.Breakpoint.LG]: {
            colSpan: 3,
            rowSpan: 3
        }
    },
    [ui_1.TileSize.XL]: {
        [Tile_contracts_1.Breakpoint.XS]: {
            colSpan: 1,
            rowSpan: 1
        },
        [Tile_contracts_1.Breakpoint.MD]: {
            colSpan: 2,
            rowSpan: 2
        },
        [Tile_contracts_1.Breakpoint.LG]: {
            colSpan: 6,
            rowSpan: 3
        }
    }
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.TILE_S_AREA = exports.tileSizeSpaceRegistry[ui_1.TileSize.S][Tile_contracts_1.Breakpoint.LG].colSpan *
    exports.tileSizeSpaceRegistry[ui_1.TileSize.S][Tile_contracts_1.Breakpoint.LG].rowSpan;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.TILE_L_AREA = exports.tileSizeSpaceRegistry[ui_1.TileSize.L][Tile_contracts_1.Breakpoint.LG].colSpan *
    exports.tileSizeSpaceRegistry[ui_1.TileSize.L][Tile_contracts_1.Breakpoint.LG].rowSpan;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.TILE_XL_AREA = exports.tileSizeSpaceRegistry[ui_1.TileSize.XL][Tile_contracts_1.Breakpoint.LG].colSpan *
    exports.tileSizeSpaceRegistry[ui_1.TileSize.XL][Tile_contracts_1.Breakpoint.LG].rowSpan;
/**
 * Registry that binds the `TileVersion` with the applicable `TileSize`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.tileVersionTileSizeRegistry = {
    [Tile_contracts_1.TileVersion.S]: ui_1.TileSize.S,
    [Tile_contracts_1.TileVersion.L]: ui_1.TileSize.L,
    [Tile_contracts_1.TileVersion.XL]: ui_1.TileSize.XL,
    [Tile_contracts_1.TileVersion.FourColumns]: ui_1.TileSize.S,
    [Tile_contracts_1.TileVersion.FiveColumns]: ui_1.TileSize.S
};
//# sourceMappingURL=Tile.config.js.map